"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledCarrierLogoContainer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _Image = _interopRequireDefault(require("../Image"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _constant = require("./constant");

var _CarrierLogo = _interopRequireDefault(require("./CarrierLogo.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var getRenderSize = function getRenderSize(_ref) {
  var _renderSizes;

  var size = _ref.size;
  var renderSizes = (_renderSizes = {}, (0, _defineProperty2.default)(_renderSizes, _constant.SIZES.SMALL, parseInt(_constant.SIZES_INT[size], 10)), (0, _defineProperty2.default)(_renderSizes, _constant.SIZES.MEDIUM, parseInt(_constant.SIZES_INT[size], 10)), (0, _defineProperty2.default)(_renderSizes, _constant.SIZES.LARGE, parseInt(_constant.SIZES_INT[size], 10)), _renderSizes);
  return renderSizes[size];
};

var getCarrierLogoSize = function getCarrierLogoSize(_ref2) {
  var theme = _ref2.theme,
      carriersLength = _ref2.carriersLength,
      size = _ref2.size;
  var defaultSizes = carriersLength > 1 ? getRenderSize({
    theme: theme,
    size: _constant.SIZES.SMALL
  }) : getRenderSize({
    theme: theme,
    size: size
  });
  return "".concat(defaultSizes - (carriersLength > 2 ? 1 : 0), "px");
};

var StyledCarrierLogoContainer = _styledComponents.default.div.withConfig({
  displayName: "CarrierLogo__StyledCarrierLogoContainer",
  componentId: "sc-7d419n-0"
})(["height:", ";width:", ";display:flex;flex-wrap:", ";align-content:space-between;justify-content:space-between;position:relative;"], function (_ref3) {
  var carriers = _ref3.carriers,
      size = _ref3.size,
      theme = _ref3.theme;
  return carriers.length > 1 ? "".concat(_constant.SIZES_INT.large, "px") : "".concat(getRenderSize({
    theme: theme,
    size: size
  }), "px");
}, function (_ref4) {
  var carriers = _ref4.carriers,
      size = _ref4.size,
      theme = _ref4.theme;
  return carriers.length > 1 ? "".concat(_constant.SIZES_INT.large, "px") : "".concat(getRenderSize({
    theme: theme,
    size: size
  }), "px");
}, function (_ref5) {
  var carriers = _ref5.carriers;
  return carriers.length > 2 && 'wrap';
});

exports.StyledCarrierLogoContainer = StyledCarrierLogoContainer;

var StyledCounter = _styledComponents.default.div.withConfig({
  displayName: "CarrierLogo__StyledCounter",
  componentId: "sc-7d419n-1"
})(["height:", ";width:", ";background:", ";border-radius:", ";display:flex;justify-content:center;align-items:center;position:absolute;right:0;bottom:0;p{color:", " !important;}.carrier{background-color:", ";border-radius:", ";&:last-child{align-self:flex-end;}}"], getCarrierLogoSize, getCarrierLogoSize, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.secondary;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.borderRadius.large;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.default;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.backgroundColor.primary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.borderRadius.normal;
});

var renderCarrierImgIcon = function renderCarrierImgIcon(carrier, theme, size, carrierLength, accessible, key, placeHolderBackground) {
  return carrier.image ? /*#__PURE__*/_react.default.createElement(_Image.default, {
    accessible: accessible,
    key: "".concat(carrier.marketingCarrierCode, "-").concat(Math.random()),
    height: getCarrierLogoSize({
      theme: theme,
      size: size,
      carriersLength: carrierLength
    }),
    width: getCarrierLogoSize({
      theme: theme,
      size: size,
      carriersLength: carrierLength
    }),
    src: carrier.image,
    alt: carrier.marketingCarrierName,
    customProperties: _objectSpread({
      title: carrier.marketingCarrierName
    }, key + 1 === carrierLength && {
      style: {
        alignSelf: 'flex-end'
      }
    }),
    radius: _constant.BORDER_RADIUS,
    placeHolderBackground: placeHolderBackground,
    theme: theme
  }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    key: Math.random(),
    accessible: true,
    color: "neutral",
    fontsize: _constant.ICON_SIZE[size],
    icon: _constant.CARRIER_ICONS[carrier.type],
    theme: "AIRASIA_CLASSIC"
  });
};

var getUniqueCarriers = function getUniqueCarriers(carriers, carriersLength) {
  var result = [];
  var map = new Map(); // eslint-disable-next-line no-restricted-syntax

  var _iterator = _createForOfIteratorHelper(carriers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var carrier = _step.value;

      if (!map.has(carrier.marketingCarrierName)) {
        map.set(carrier.marketingCarrierName, true); // set any value to Map

        result.push({
          name: carrier.marketingCarrierName,
          code: carrier.marketingCarrierCode,
          image: carrier.image
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (result.length < carriersLength) {
    // if length is not the same, there's a duplicate removed
    return result;
  } // else return default carriers


  return carriers;
};

var CarrierLogo = function CarrierLogo(_ref11) {
  var size = _ref11.size,
      _ref11$carriers = _ref11.carriers,
      carriers = _ref11$carriers === void 0 ? [] : _ref11$carriers,
      theme = _ref11.theme,
      accessible = _ref11.accessible,
      placeHolderBackground = _ref11.placeHolderBackground,
      customProperties = _ref11.customProperties;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var uniqueCarriers = getUniqueCarriers(carriers, carriers.length);
  var carrierLength = uniqueCarriers.length;

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(StyledCarrierLogoContainer, (0, _extends2.default)({
      carriers: uniqueCarriers,
      size: size,
      theme: theme,
      tabIndex: !accessible ? '-1' : '0'
    }, customProperties), uniqueCarriers.length > 0 && uniqueCarriers.slice(0, 3).map(function (carrier, key) {
      return key < 2 ? renderCarrierImgIcon(carrier, theme, size, carrierLength, accessible, key, placeHolderBackground) : /*#__PURE__*/_react.default.createElement(StyledCounter, {
        carriersLength: carrierLength,
        size: size,
        key: "".concat(carrier.code, "-").concat(Math.random())
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        accessible: accessible,
        display: "inlineFlex",
        theme: theme,
        type: "small",
        textAlign: "center"
      }, "+", carrierLength - 2));
    }));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

CarrierLogo.propTypes = _CarrierLogo.default.PropTypes;
CarrierLogo.defaultProps = _CarrierLogo.default.DefaultProps;
var _default = CarrierLogo;
exports.default = _default;